import { useEffect, useState } from 'react'

function readStored(key, fallback) {
  const raw = localStorage.getItem(key)
  if (raw === null) return fallback
  try { return JSON.parse(raw) } catch { return fallback }
}

// useState that survives reloads, stored as JSON under `key` in localStorage.
export function usePersistentState(key, fallback) {
  const [value, setValue] = useState(() => readStored(key, fallback))
  useEffect(() => { localStorage.setItem(key, JSON.stringify(value)) }, [key, value])
  return [value, setValue]
}
